module.exports = __webpack_public_path__ + "img/edit.ca92e96f.svg";